<template>
  <RoundButton small @click.native="$emit('prev')">
    <svg class="icon" viewBox="0 0 23.5 27.69"><path d="M17.35 27.69H22a1.54 1.54 0 0 0 1.54-1.54V1.54A1.54 1.54 0 0 0 22 0h-4.65a1.54 1.54 0 0 0-1.54 1.54v24.61a1.54 1.54 0 0 0 1.54 1.54zM0 13.83V0l7.24 6.92 7.23 6.91-7.23 6.92L0 27.66V13.83z" fill="#fff"/></svg>
  </RoundButton>
</template>

<script>
import RoundButton from '@/components/RoundButton'

export default {
  name: 'NextButton',
  components: {
    RoundButton
  }
}
</script>

<style lang="scss" scoped>
.icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 23.5px;
  height: 27.69px;
}
</style>
